import React, { Fragment, useState, useEffect, useContext } from 'react';
import { getSortedProducts } from '../../helpers/product'
import { multilanguage } from "redux-multilanguage";
import StaticContent from "../../context/ContentContext";
import Logo from './Logo';

const StoryMenu = () => {
    const menuJson = useContext(StaticContent);
    const footerData = menuJson && menuJson?.content?.contentManagement?.data?.content?.items[0]?.footer

    const quickData = menuJson && menuJson?.content?.contentManagement?.data?.content?.items[0]?.quickLink

    const storyMenuList= [
        {imageUrl: '/assets/img/image3.png', link: '/shop', text: 'T-shirts'},
        {imageUrl: '/assets/img/image2.png', link: '/shop', text: 'Headwear'},
        {imageUrl: '/assets/img/image10.png', link: '/shop', text: 'Promotional Products'},
        {imageUrl: '/assets/img/image12.png', link: '/shop', text: 'Polos'},
        {imageUrl: '/assets/img/image4.png', link: '/shop', text: 'Sweatshirts and Hoodies'},
        {imageUrl: '/assets/img/image5.png', link: '/shop', text: 'Safety'},
        {imageUrl: '/assets/img/image8.png', link: '/shop', text: 'Outer Wear'},
        {imageUrl: '/assets/img/image9.png', link: '/shop', text: 'Button Downs'},
        {imageUrl: '/assets/img/image11.png', link: '/shop', text: 'Best Sellers'},
        {imageUrl: '/assets/img/image7.png', link: '/shop', text: 'Ideas'},
        {imageUrl: '/assets/img/image6.png', link: '/shop', text: 'New'},
        {imageUrl: '/assets/img/image1.png', link: '/shop', text: 'Our Team'},
    ]

      return (
  
                        <div className="d-none d-lg-block">
                            <div className="container" style={{ maxWidth: '1250px' }}>
                                <nav className="thumbs-nav w-100">
                                    <ul className="thumbs d-flex justify-content-center mb-2 row">
                                        {/* <li className="thumb-item col-1">
                                            <a>
                                            <i className="fa fa-bars bg-primary" />Categories
                                            </a>
                                        </li> */}
                                        <li>
                                            <Logo
                                                // imageUrl={"https://caa-jthanna-bucket.s3.us-east-2.amazonaws.com/uploads/JTH Logo.png"}
                                                imageUrl={footerData?.footerCopyrightSection?.footerLogo}
                                                logoClass="logo"
                                            />
                                        </li>

                                        {quickData?.map((data, idx) => {
                                            return(
                                            <li className="thumb-item col-1" onClick={() => window.location = data.link}  key={idx}>
                                                <a className=" has-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: `url("${data.imageUrl}")`}} />{data.text}
                                            </a>
                                        </li>
                                            )
                                        })}
                                        
                                        {/* <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image2.png")'}} />Headwear
                                            </a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image10.png")'}} />Promotional Products
                                            </a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image12.png")'}} />Polos</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image4.png")'}} />Sweatshirts and Hoodies
                                            </a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image5.png")'}} />
                                            </span>Safety</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview story-button">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image8.png")'}} />
                                            </span>Outer Wear</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview story-button">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image9.png")'}} />
                                            </span>Button Downs</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image11.png")'}} />
                                            </span>Best Sellers</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image7.png")'}} />
                                            </span>Ideas</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview story-button">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image6.png")'}} />
                                            </span>New</a>
                                        </li>
                                        <li className="thumb-item col-1" onClick={() => window.location = '/shop'}>
                                            <a className=" has-preview story-button">
                                            <span className="thumb-info thumb-info-preview">
                                            <span className="thumb-info-image fixed-image" style={{backgroundImage: 'url("/assets/img/image1.png")'}} />
                                            </span>Our Team</a>
                                        </li> */}
                                    </ul>
                                </nav>
                            </div>
                        </div>
      );
    }

    export default multilanguage(StoryMenu);